<template>
  <layout>
    <!--城市选择区-->
    <template v-slot:pageLeft>
      <QHleftcity @change="change" @cityLoading="cityLoading" ref="QHleftcity"></QHleftcity>
    </template>
    <!--城市选择区 end-->

    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">处置单位</font>
        </div>
      </div>
      <div class="headerB flex-between">
        <div class="flex-center-y">
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>{{ dataName }}</p>
                <p>单位数量</p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.pageCount || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">个</div>
            </dt>
          </dl>
        </div>
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li>
          <Select v-model="searchMap.compnayType" @on-change="search()" slot="prepend" style="width: 110px" placeholder="全部分类">
            <Option value="">全部分类</Option>
            <Option value="100">临时堆放</Option>
            <Option value="200">资源利用</Option>
            <Option value="300">分拣中心</Option>
            <Option value="400">工程回填</Option>
            <Option value="500">装卸码头</Option>
            <Option value="600">跨市处理</Option>
            <Option value="700">移动收集箱</Option>
          </Select>
        </li>
        <li style="width: 220px">
          <Input size="small" v-model="searchMap.keyword" placeholder="请输入关键词">
            <Select v-model="searchMap.likeNameA" slot="prepend" style="width: 90px">
              <Option value="A.orgName">单位名称</Option>
              <Option value="A.addressFull">所在地区</Option>
            </Select>
          </Input>
        </li>
        <li>
          <Button type="warning" size="small" @click="search">查询</Button>
        </li>
        <li>
          <Button type="primary" @click="uploadExcel" size="small" >导出公司</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
          <!--分割区-->
          <template slot-scope="{ row }" slot="companyType">
            <span v-if="row.compnayType == 100">临时堆放</span>
            <span v-if="row.compnayType == 200">资源利用</span>
            <span v-if="row.compnayType == 300">分拣中心</span>
            <span v-if="row.compnayType == 400">工程回填</span>
            <span v-if="row.compnayType == 500">装卸码头</span>
            <span v-if="row.compnayType == 600">跨市处理</span>
            <span v-if="row.compnayType == 700">移动收集箱</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="canUnloadCar">
            <span v-if="row.canUnloadCar == 100">仅接收自己</span>
            <span v-if="row.canUnloadCar == 200">仅接收三方</span>
            <span v-if="row.canUnloadCar == 300">自己及三方</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="allQualificationsCount">
            <b style="font-size: 18px; color: #01aaed" v-if="row.allQualificationsCount > 0">{{ row.allQualificationsCount }}</b>
            <b style="font-size: 18px; color: #bbb" v-if="row.allQualificationsCount == 0">{{ row.allQualificationsCount }}</b>
            <b style="color: #bbb">/</b>
            <b style="font-size: 18px; color: #ed4014" v-if="row.invalidQualificationsCount > 0">{{ row.invalidQualificationsCount }}</b>
            <b style="font-size: 18px; color: #bbb" v-if="row.invalidQualificationsCount == 0">{{ row.invalidQualificationsCount }}</b>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="action">
            <Button type="warning" size="small" @click="$goQiyeBigscreen(row.id,7)">详情</Button>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <template v-slot:pageBlock>
      <detailed ref="detailed"></detailed>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
export default {
  components: {
    detailed,
  },
  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      loading: false,
      pageThis: this,
      selectedRows: [],
      columns: this.$colFilter([
        {
          title: "接收单位",
          key: "orgName",
          className: "hotFont13",
          minWidth: 280,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "单位类型",
          align: "center",
          width: 100,
          slot: "companyType",
        },
        {
          title: "所属区县",
          key: "districtName",
          align: "center",
          width: 100,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "所属街道",
          key: "streetName",
          align: "center",
          width: 100,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "处置容量",
          align: "center",
          width: 100,
          render: (h, parameter) => {
            var row = parameter.row;
            let txt = this.$xiaoshu(row.capacity) + "m³";
            return h("span", txt);
          },
        },
        {
          title: "已处置量",
          align: "center",
          width: 100,
          render: (h, parameter) => {
            var row = parameter.row;
            let txt = this.$xiaoshu(row.garbageNumber) + "m³";
            return h("span", txt);
          },
        },
        {
          title: "电子围栏",
          align: "center",
          width: 100,
          render: (h, parameter) => {
            var row = parameter.row;
            let txt = "方圆" + row.authJuli + "米";
            return h("span", txt);
          },
        },
        {
          title: "处置方式",
          align: "center",
          width: 100,
          key: "chuzhiWay",
        },
        {
          title: "工作时间",
          align: "center",
          key: "workTime",
          width: 100,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "接收许可",
          align: "center",
          width: 100,
          slot: "canUnloadCar",
        },
        {
          title: "联系姓名",
          width: 100,
          align: "center",
          key: "contactName",
        },
        {
          title: "联系电话",
          width: 110,
          align: "center",
          key: "contactTel",
        },
        {
          title: "开通时间",
          key: "created",
          width: 135,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.created, "YYYY-MM-DD HH:mm");
            return h("span", time);
          },
        },
        {
          title: "资质/异常",
          width: 100,
          align: "center",
          fixed: "right",
          slot: "allQualificationsCount",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 80,
          slot: "action",
          align: "center",
        },
      ]),

      //搜索配置项@@@@@@@@@@@@@@@@@@@@@@@
      searchMap: {
        compnayType: "",
        likeNameA: "A.orgName",
        keyword: "",
        status: 100,
        pageNo: 1,
        pageSize: 25,
      },
      total: {},
      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      dataLoading: false,
      dataName: "",
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    this.searchMap.compnayType = this.$getUrlParams("compnayType");
    this.$refs.QHleftcity.int();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 切换数据地址数据
    // +----------------------------------------------------------------------
    change(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.dataName = res.name;
      this.dataLoading = false;
    },

    cityLoading(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;

      this.getList();
    },

    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      var https = {
        type: "isPagelist",
        api: this.$api.getOrgjieshouList,
        parameter: this.searchMap,
      };
      this.$httpsApi(https, function () {
        that.dataLoading = true;
      });
    },
  // +----------------------------------------------------------------------
        // | 导出excel
        // +----------------------------------------------------------------------
        uploadExcel() {
            this.$loading(true);
            this.searchMap.ids = this.selectedRows;
            var obj1 = this.searchTemp;
            var obj2 = this.searchMap;
        
            this.searchMap = { ...obj2, ...obj1 };
            
            var parameter = this.searchMap;
            var url = "/zxbigscreen/Orgjieshou/uploadExcel";
            var fileName = "处置单位.xlsx";
            this.$downLoad(url,parameter,fileName);
            this.$loading(false);
        },
    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search(status) {
      if (!this.$isblank(status)) {
        this.searchMap.status = status;
      }
      this.getList();
    },
  },
};
</script>
